import React, { useState, useEffect, useRef } from "react";
import {
  f7,
  Page,
  Icon,
  Link,
  Input,
  Button,
  Popup,
  Segmented,
  Toggle,
  ListItem,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";

const EventDetailPage = ({ f7route }) => {
  const { eid, os } = f7route.params;
  const [data, setEventDetails] = useState([]);
  const [menuId, setMenuId] = useState(0);
  const [menuAmount, setMenuAmount] = useState(0);
  const [bidMenu, setBidMenu] = useState([]);
  const formRef = useRef(null);
  const [remainingTime, setRemainingTime] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addMenuBtn, setAddMenuBtn] = useState(false);
  const [noOfPer, setNoOfPer] = useState(0);
  const [menuNote, setMenuNote] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  const [allMenuItems, setAllMenuItems] = useState([]);
  const [calculatedValues, setCalculatedValues] = useState({
    sub_total: 0,
    discount: 0,
    total_amt: 0,
    sales_tax: 0,
    total: 0,
  });
  const [reviewData, setReviewData] = useState({
    sub_total: 0,
    discount: 0,
    total_amt: 0,
    sales_tax: 0,
    total: 0,
  });
  const [isSalesTaxEnabled, setSalesTaxEnabled] = useState(true);
  const handleSalesTaxToggle = () => {
    setSalesTaxEnabled(!isSalesTaxEnabled);
  };
  const [formData, setFormData] = useState([]);

  let totalAmount = 0;
  useEffect(() => {
    bidMenu.map((item) => {
      totalAmount += item.total_amount;
    });
    console.log("totalAmount", totalAmount);
    const sub_total = totalAmount;
    const discount = formData.discount > 0 ? formData.discount : 0;
    const total_amt = sub_total - discount > 0 ? sub_total - discount : 0;
    let sales_tax = 0;
    if (isSalesTaxEnabled) {
      sales_tax = parseFloat(total_amt * (formData.sales_tax / 100)).toFixed(2);
    } else {
      sales_tax = 0;
    }
    const total = parseFloat(total_amt) + parseFloat(sales_tax);
    // console.log(sales_tax);

    // Update state with calculated values
    setCalculatedValues({
      sub_total,
      discount,
      total_amt,
      sales_tax,
      total,
    });
    setFormData({
      ...formData,
      tax: sales_tax,
      grand_total: total,
    });
    // formData.tax = sales_tax;
    // formData.grand_total = total;
  }, [
    bidMenu,
    formData.discount,
    formData.sales_tax,
    isSalesTaxEnabled,
    totalAmount,
  ]);

  const discountAddItem = (e) => {
    var discount = parseFloat(e.target.value);
    var sub_amt = parseFloat(totalAmount);
    var total_amount = sub_amt - discount;
    // setTotalAmount(total_amount);

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      grand_total: total_amount > 0 ? total_amount : formData.sub_total,
      // ["grand_total"]: total_amount > 0 ? total_amount : formData.sub_total,
    });
  };

  // console.log("setBidMenu", bidMenu);
  let TotalAmount = 0;
  useEffect(() => {
    console.log(os);
    axios
      .get(
        API_BASE_URL +
          "eventbyrest/id/" +
          localStorage.getItem("id") +
          "/?event_id=" +
          eid,
        {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
          params: {
            order_status: os,
            ...(os == 2 ? { type: "restaurant" } : {}),
          },
        }
      )
      .then((response) => {
        setEventDetails(response.data.data);
        const eventDetails = response.data.data;
        const filteredBidMenu = response.data.data[0].rest_item
          .filter((item) => item.status === null)
          .map((item) => {
            // Destructure the object and exclude the 'size' key
            const {
              id,
              discount_amount,
              event_id,
              menu_size_name,
              qty,
              status,
              ...rest
            } = item;
            return {
              ...rest,
              item_status: 2,
              request_menu_name: item?.request_menu_name,
              request_menu_id: item?.request_menu_id,
            };
          });
        setBidMenu(filteredBidMenu);
        setAllMenuItems(response.data.data[0].item);
        setFormData({
          ...formData,
          sales_tax: response.data.data[0].sales_tax,
          discount: response.data.data[0].discount,
        });
        setSalesTaxEnabled(response.data.data[0].tax == 0 ? false : true);
        let total = 0;

        response.data.data?.map((item) =>
          item?.rest_item?.map((items, index) => (total += items?.total_amount))
        );

        const total_amt =
          total - response.data.data[0].discount > 0
            ? total - response.data.data[0].discount
            : 0;
        let sales_tax = 0;
        sales_tax = parseFloat(
          total_amt * (response.data.data[0].tax / 100)
        ).toFixed(2);
        const Total = parseFloat(total_amt) + parseFloat(sales_tax);

        setReviewData({
          ...reviewData,
          discount: response.data.data[0].discount,
          tax: response.data.data[0].tax,
          sales_tax: sales_tax,
          total: parseFloat(Total).toFixed(2),
        });
      })
      .catch((error) => console.log(error));
  }, [eid]);

  useEffect(() => {
    // Filter data based on event_item_id not found in bidMenu
    const filteredItems = allMenuItems.filter((item) => {
      return !bidMenu.some(
        (bidItem) => bidItem.event_item_id === item.event_item_id
      );
    });
    // console.log("filteredItems", filteredItems);

    setMenuItems(filteredItems);
  }, [bidMenu, allMenuItems]);

  const filteredData = Object.values(
    bidMenu.reduce((acc, obj) => {
      acc[obj.event_item_id] = obj;
      return acc;
    }, {})
  );

  useEffect(() => {
    // const dateString = data.map( item => item.bid_start_date)[0];
    // const dateString = "10-28-2023 09:47 am";
    // console.log("data.bid_end_date", data[0]?.is_direct_order);
    const dateString = Date().toLocaleString();
    const dateObject = new Date(dateString);
    const secondsSinceEpoch = Math.floor(dateObject.getTime() / 1000);
    const dateString1 =
      data[0]?.is_direct_order == 1
        ? data.map((item) => item.bid_event_date)[0]
        : data.map((item) => item.bid_end_date)[0];
    const dateObject1 = new Date(dateString1);
    const secondSinceEpoch1 = Math.floor(dateObject1.getTime() / 1000);
    const remaining_time = secondSinceEpoch1 - secondsSinceEpoch;
    setRemainingTime(remaining_time);
    const remainingTime = Math.floor(dateObject.getTime() / 1000);
    const interval = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime((prevTime) => prevTime - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [data]);

  const formatTime = (timeInSeconds) => {
    const days = Math.floor(timeInSeconds / 86400); // 1 day has 86400 seconds
    const hours = Math.floor((timeInSeconds % 86400) / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return `${days.toString().padStart(2, "0")} Days - ${hours
      .toString()
      .padStart(2, "0")} : ${minutes.toString().padStart(2, "0")} : ${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const config = {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      };
      const response = await axios.get(
        API_BASE_URL + "menubyrest/id/" + localStorage.getItem("id"),
        config
      );
      setOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [requestedMenu, setRequestedMenu] = useState("");
  const [requestedMenuId, setRequestedMenuId] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [menuSize, setMenuSize] = useState([]);
  const [eventItemId, setEventItemId] = useState();
  const [traySizeId, setTraySizeId] = useState();
  const [menuSizeId, setMenuSizeId] = useState();
  console.log("requestedMenuId", requestedMenuId);
  const handleMenuChange = (event) => {
    setSuggestions([]);
    const value = event.target.value;
    if (value.length > 0) {
      axios
        .get(
          API_BASE_URL +
            `menu/?search=${value}&rest_id=${localStorage.getItem("id")}`,
          {
            // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
            headers: {
              Authorization: "Basic " + API_AUTH,
            },
          }
        )
        .then((response) => {
          setSuggestions(response.data);
        })
        .catch((error) => {
          console.log(error);
          setSuggestions([]);
        });
    } else {
      setSuggestions([]);
    }
    setSearchTerm(value);
    setMenuAmount(0);
    setMenuSize([]);
  };

  const handleItemClick = (item, id, menu_size) => {
    setSuggestions("");
    setSearchTerm(item);
    setSuggestions("");
    setMenuSize(menu_size);
    setRequestedMenuId(id);
    setMenuId(id);
  };
  const handleReviewItemClick = (item, id, menu_size) => {
    setSuggestions("");
    setSearchTerm(item);
    setSuggestions("");
    setMenuSize(menu_size);
    // setRequestedMenuId(id);
    setMenuId(id);
  };

  const handleItemSelect = (item, id, menu_size) => {
    setSuggestions("");
    setSearchTerm(item);
    setSuggestions("");
    setMenuSize(menu_size);
    setMenuId(id);
  };

  const menuSizeAmount = (amount, noOfPer) => {
    setMenuAmount(amount);
    setNoOfPer(noOfPer);
  };

  const newoptions = [
    { value: 1, label: "John Doe" },
    { value: 2, label: "Jane Smith" },
    { value: 3, label: "Alice Johnson" },
  ];

  const fetchAutocompleteData = async (inputValue) => {
    try {
      const response = await axios.get("your-api-url", {
        params: { search: inputValue },
      });
      setOptions(response.data);
    } catch (error) {
      console.error("Error fetching autocomplete data:", error);
    }
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };
  const handleMenuAmountChange = (event) => {
    setMenuAmount(event.target.value);
  };
  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
    fetchAutocompleteData(inputValue);
  };

  const acceptOrder = (id) => {
    const accept_array = {
      rest_id: localStorage.getItem("id"),
    };
    axios
      .put(API_BASE_URL + "acceptbyrest/id/" + id, accept_array, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.views.main.router.navigate("/main/", {
          reloadAll: true,
        });
        f7.tab.show("#tab-3");
        f7.toast
          .create({
            text: "Bid Accepted..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
      });
  };
  const [cancelReason, setCancelReason] = useState("");
  // console.log("setCancelReason", cancelReason);
  const cancelConfirm = (id) => {
    let reason = "";

    const dialog = f7.dialog.create({
      title: "Cancel Bid",
      text: "Do you want to cancel the bid?",
      content: `
        <div class="dialog-input-field" >
        <input type="text" id="cancel-reason" class="dialog-input" placeholder="Enter reason for cancellation">
        </div>
      `,
      buttons: [
        {
          text: "Cancel",
          onClick: () => {
            console.log("Cancel button clicked");
            dialog.close();
          },
        },
        {
          text: "OK",
          onClick: () => {
            reason = document.getElementById("cancel-reason").value;
            cancelOrder(id, reason);
            dialog.close();
          },
        },
      ],
      on: {
        opened: () => {
          document.getElementById("cancel-reason").focus();
        },
      },
    });

    dialog.open();
  };

  const cancelOrder = (id, reason) => {
    console.log("setCancelReason id", reason, id);
    setCancelReason(reason);
    const cancel_array = {
      rest_id: localStorage.getItem("id"),
      reason: reason,
    };
    axios
      .put(API_BASE_URL + "cancelevent/id/" + id, cancel_array, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.views.main.router.navigate("/main/", {
          reloadAll: true,
        });
        f7.tab.show("#tab-3");
        f7.toast
          .create({
            text: "Order Cancelled..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
      });
  };
  const filterOptions = (inputValue) => {
    return options.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const formatOptions = () => {
    return options.map((option) => ({
      value: option.id,
      label: option.name,
    }));
  };
  const [totalAmt, setTotalAmt] = useState(0);
  const calculateSum = (traySizeId) => {
    var unitAmt = traySizeId * menuAmount;
    setTotalAmt(unitAmt);
  };
  useEffect(() => {
    calculateSum(traySizeId);
  }, [traySizeId, menuAmount]);
  const removeItem = (index) => {
    const updatedProduct = [...bidMenu];
    updatedProduct.splice(index, 1);
    setBidMenu(updatedProduct);
  };

  const addToItem = (keyName) => {
    formRef.current.reset();
    setSearchTerm("");
    setTotalAmt(0);
    setMenuAmount(0);
    setAddMenuBtn(false);
    setSuggestions([]);

    const value = keyName;
    axios
      .get(
        API_BASE_URL +
          `menu/?search=${value}&rest_id=${localStorage.getItem("id")}`,
        {
          // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        }
      )
      .then((response) => {
        handleItemClick(
          response.data[0].menu_item_name,
          response.data[0].menu_item_id,
          response.data[0].menu_size
        );
        f7.popup.open(".demo-popup");
      })
      .catch((error) => {
        f7.popup.open(".demo-popup");
        console.log(error);
        setSuggestions([]);
        setAddMenuBtn(true);
      });
  };

  const reviewAddToItem = (keyName) => {
    formRef.current.reset();
    setSearchTerm("");
    setTotalAmt(0);
    setMenuAmount(0);
    setAddMenuBtn(false);
    setSuggestions([]);

    const value = keyName;
    axios
      .get(
        API_BASE_URL +
          `menu/?search=${value}&rest_id=${localStorage.getItem("id")}`,
        {
          // Replace with the desired HTTP method (e.g., POST, PUT, DELETE)
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        }
      )
      .then((response) => {
        handleReviewItemClick(
          response.data[0].menu_item_name,
          response.data[0].menu_item_id,
          response.data[0].menu_size
        );
        // setRequestedMenuId(response?.data[0]?.menu_item_id);

        f7.popup.open(".demo-popup");
      })
      .catch((error) => {
        f7.popup.open(".demo-popup");
        console.log(error);
        setSuggestions([]);
        setAddMenuBtn(true);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const requested_menu_name = requestedMenu;
    const request_menu_id = requestedMenuId;
    const menu_name = event.target.elements.menu_name.value;
    const menu_id = menuId;
    const rest_id = localStorage.getItem("id");
    const tray_size_id = event.target.elements.try_size.value;
    const menu_size = event.target.elements.menu_size.value;
    const size = event.target.elements.noOfPer.value;
    const menu_amount = event.target.elements.menu_amount.value;
    const note = menuNote;
    // console.log(menu_name,menu_id,rest_id)
    if (menu_size == "Select Menu Size") {
      f7.toast
        .create({
          text: "Please Select Menu Size ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    if (menu_amount <= 0) {
      f7.toast
        .create({
          text: "Please Add Amount ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    if (tray_size_id <= 0 || !tray_size_id) {
      f7.toast
        .create({
          text: "Please Add Menu Details ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }

    if (totalAmt <= 0) {
      f7.toast
        .create({
          text: "Please Add Tray Size ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return;
    }
    const menu_data = {
      request_menu_name: requested_menu_name,
      request_menu_id: request_menu_id,
      menu_name: menu_name,
      menu_id: menu_id,
      rest_id: rest_id,
      tray_size_id: tray_size_id,
      menu_amount: menu_amount,
      note: note,
      size: noOfPer,
      item_status: 2,
      total_amount: totalAmt,
      menu_size: menu_size,
      event_item_id: eventItemId,
    };

    setBidMenu([...bidMenu, menu_data]);

    f7.popup.close(".demo-popup");
    formRef.current.reset();
    setSearchTerm("");
    setTotalAmt(0);
    setMenuAmount(0);
    setNoOfPer(0);
  };

  useEffect(() => {
    const filteredData = Object.values(
      bidMenu.reduce((acc, obj) => {
        acc[obj.event_item_id] = obj;
        return acc;
      }, {})
    );
    if (filteredData.length !== bidMenu.length) {
      setBidMenu(filteredData);
    }
  }, [bidMenu]);
  const showConfirm = (e) => {
    e.preventDefault();
    const discountInput = document.querySelector("input[name='discount']");

    // Check if the discount input field is valid
    if (!discountInput.checkValidity()) {
      // If the input is invalid, show an error message and prevent further actions
      f7.toast
        .create({
          text: "Please enter a valid discount value.",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      return; // Stop the function from proceeding
    }
    f7.dialog.confirm(
      "Do you want to submit the bid?",
      "Submit Bid",
      () => {
        bidAcceptSubmit(e);
      },
      () => {
        // Cancel button clicked
        console.log("Cancel button clicked");
      }
    );
  };
  const bidAcceptSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    // console.log(bidMenu);
    console.log(data[0].item.length);
    if (bidMenu.length < 1) {
      //  !== data[0].item.length
      f7.toast
        .create({
          text: "Please Add Menu As Customer Required ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
          handleItemClick,
        })
        .open();
      setIsSubmitting(false);
      return;
    }

    if (bidMenu.length <= 0) {
      f7.toast
        .create({
          text: "Please Add Menu Details ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      setIsSubmitting(false);
      return;
    }
    if (calculatedValues?.total <= 0) {
      f7.toast
        .create({
          text: "Total can not be zero..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      setIsSubmitting(false);
      return;
    }
    if (remainingTime <= 0) {
      f7.toast
        .create({
          text: "Time Out ..!",
          position: "top",
          cssClass: "bg-color-red",
          closeTimeout: 3000,
        })
        .open();
      setIsSubmitting(false);
      return;
    }
    const modifiedBidMenu = bidMenu.map((item) => {
      // Destructure the object and exclude the 'size' key
      const { size, ...rest } = item;
      return rest;
    });
    const modifiedMenuItems = menuItems.map((item) => {
      const {
        id,
        discount_amount,
        menu_amount,
        note,
        qty,
        rest_id,
        total_amount,
        ...rest
      } = item; // Exclude the 'id' key
      return {
        ...rest,
        item_status: 2,
        status: 1,
      };
    });
    const menu_item = {
      rest_id: localStorage.getItem("id"),
      event_id: data.map((item) => item.id)[0],
      cust_id: data.map((item) => item.cust_id)[0],
      event_status: 2,
      discount: formData.discount,
      tax: isSalesTaxEnabled ? formData.sales_tax : 0,
      item: [...modifiedBidMenu, ...modifiedMenuItems],
    };

    axios
      .post(API_BASE_URL + "resteventitem", menu_item, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.views.main.router.navigate("/main/", {
          reloadAll: true,
        });
        f7.tab.show("#tab-3");
        f7.toast
          .create({
            text: "Bid Submitted ..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
      })
      .catch((error) => {
        f7.dialog.alert("Error updating data!");
        setIsSubmitting(false);
      })
      .finally(() => {
        setIsSubmitting(false); // Re-enable the button after registration attempt
      });
  };
  data.map((item) =>
    item.rest_item.map((items, index) => (TotalAmount += items.total_amount))
  );

  const addNewMenu = () => {
    f7.popup.close(".demo-popup");
    f7.views.main.router.navigate("/addmenupopup/");
  };

  // export default function EventDetailPage() {
  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>{" "}
                  <span className="text-dark d-none d-md-block">Back</span>
                </Link>
                <h2>Event Details</h2>
              </div>
            </div>
          </header>
          {data.map((item) => (
            <section className="profile-form mt-3">
              <div className="custom-container p-0">
                <div class="title">
                  <h5 className="fw-bold dark-text dark-text">
                    <span className="light-text">Event ID : </span>{" "}
                    {item.event_id}
                  </h5>
                  <a href="#" className="text-muted text-1">
                    {item.bid_start_date}
                  </a>
                </div>
                <div className="apply-coupon mt-3">
                  <h5>
                    Status:{" "}
                    <span className="text-success">
                      {item.order_status === 5
                        ? item.order_status_text
                        : item.status_of_event !== null
                        ? item.status_of_event
                        : "Requested"}
                    </span>
                  </h5>
                </div>
                {/* { item.status_of_event < 2 && remainingTime > 0 ?( */}
                {remainingTime > 0 ? (
                  <div className="rounded p-3 bg-warning mt-2 text-center">
                    <h3>Bid expires in</h3>
                    <h1>{formatTime(remainingTime)}</h1>
                  </div>
                ) : (
                  ""
                )}
                {remainingTime <= 0 ? (
                  <div className="rounded p-3 bg-light mt-2 text-center">
                    <h3 className="text-danger"> Bid expired..! </h3>
                  </div>
                ) : (
                  ""
                )}
                <table className="table 1table-borderless mt-2 text-2">
                  <tbody>
                    <tr>
                      <td width={"40%"}>Event Name: </td>
                      <td>
                        <b>{item.event_name}</b>
                      </td>
                    </tr>
                    <tr>
                      <td width={"40%"}>Event Date : </td>
                      <td>{item.event_date} </td>
                    </tr>
                    <tr>
                      <td>Event Size: </td>
                      <td>
                        {item.event_adult_size !== null &&
                          item.event_adult_size !== undefined && (
                            <span>
                              Adults - <strong>{item.event_adult_size}</strong>
                            </span>
                          )}
                        {item.event_kids_size !== null &&
                          item.event_kids_size !== undefined && (
                            <span>
                              , Kids - <strong>{item.event_kids_size}</strong>
                            </span>
                          )}
                      </td>
                    </tr>
                    <tr>
                      <td>Food Need By Time: </td>
                      <td>{item.event_by_time}</td>
                    </tr>
                    <tr>
                      <td>Event Address: </td>
                      {item.delivery_type !== "Pick up" ? (
                        <td>
                          {item.add_lin_1} {item.add_lin_2} {item.city}{" "}
                          {item.state} {item.zip_code}
                        </td>
                      ) : (
                        <td></td>
                      )}
                    </tr>
                    <tr>
                      <td>Deliver Type: </td>
                      <td>{item.delivery_type}</td>
                    </tr>
                    <tr>
                      <td>Event Notes: </td>
                      <td>{item.event_note}</td>
                    </tr>
                  </tbody>
                </table>

                {/* <h3 className="fw-bold dark-text mb-2">Restaurant Information</h3> */}
                {/* <div className="vertical-product-box">
                  <div className="vertical-box-img p-2" style={{width: '15%'}}>
                    <img alt="" slot="media" src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg" width="40" className="rounded-circle" />
                  </div>
                  <div className="vertical-box-details">
                    <div className="vertical-box-head">
                      <div className="restaurant">
                        <h5 className="dark-text">Ben &amp; Floren</h5>
                      </div>
                      <h6 className="food-items mb-2" style={{overflow: 'visible'}}><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> 8642 Yule Street, Arvada CO 80007</h6>                    
                    </div>              
                  </div>
                </div> */}
              </div>
              {item.status_of_event_id !== 2 &&
              item.status_of_event_id !== 6 &&
              item.order_status === 1 ? (
                <div className="custom-container p-0">
                  {menuItems.length > 0 ? (
                    <h3 className="fw-bold dark-text">Menu Items</h3>
                  ) : (
                    ""
                  )}
                  <table className="table table-striped table-sm text-2 mt-2">
                    <tbody>
                      {menuItems.map((items, index) => (
                        <tr className="align-middle">
                          <td width={"10%"} className="text-center">
                            {index + 1}.{" "}
                          </td>
                          <td>
                            <h5 className="dark-text fw-bold mb-1 text-capitalize">
                              {items.menu_name}
                            </h5>
                            {items.note}
                          </td>
                          <td width={"10%"}>
                            {item.status_of_event_id !== 2 &&
                            item.status_of_event_id !== 6 &&
                            item.order_status === 1 ? (
                              <Button
                                className={`${
                                  remainingTime < 0 ? "disabled" : ""
                                }`}
                                onClick={() => {
                                  setRequestedMenuId("");
                                  addToItem(items.menu_name);
                                  setRequestedMenu(items?.menu_name);
                                  setEventItemId(items.id);
                                  setTraySizeId("");
                                  setMenuSizeId("");
                                  setMenuAmount(0);
                                  setNoOfPer(0);
                                  setMenuNote("");
                                }}
                              >
                                <Icon
                                  material="edit"
                                  className="text-success"
                                ></Icon>
                              </Button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Menu Items</h3>
                  <table className="table table-striped table-sm text-2 mt-2">
                    <tbody>
                      {item.item.map((items, index) => (
                        <tr className="align-middle">
                          <td width={"10%"} className="text-center">
                            {index + 1}.{" "}
                          </td>
                          <td>
                            <h5 className="dark-text fw-bold mb-1 text-capitalize">
                              {items.menu_name}
                            </h5>
                            {items.note}
                          </td>
                          <td width={"10%"}>
                            {item.status_of_event_id !== 2 &&
                            item.status_of_event_id !== 6 &&
                            item.order_status === 1 ? (
                              <Button
                                className={`${
                                  remainingTime < 0 ? "disabled" : ""
                                }`}
                                onClick={() => addToItem(items.menu_name)}
                              >
                                <Icon
                                  material="edit"
                                  className="text-success"
                                ></Icon>
                              </Button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {item.status_of_event_id === 2 &&
              item.status_of_event_id !== 6 &&
              item.order_status === 2 &&
              item.rest_item.length > 0 ? (
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Confirmed Menu Items</h3>
                  <table className="table table-striped table-sm text-2 mt-2">
                    <tbody className="mt-2 ">
                      {item.rest_item
                        .filter((items) => items.status !== 1) // Filter items with status !== 1
                        .map((items, index) => (
                          <tr key={index}>
                            <td width={"10%"} className="text-center">
                              {index + 1}.
                            </td>
                            <td colSpan={3}>
                              {items.request_menu_name === items.menu_name ? (
                                <h5 className="dark-text fw-bold mb-1 text-capitalize">
                                  {items.menu_name}
                                </h5>
                              ) : (
                                <>
                                  <div style={{ display: "flex" }}>
                                    <h5 style={{ marginRight: "10px" }}>
                                      Requested:
                                    </h5>
                                    <h5
                                      className="dark-text fw-bold mb-1"
                                      style={{
                                        textDecoration: "line-through",
                                        color: "black",
                                        textDecorationColor: "red",
                                      }}
                                    >
                                      {items.request_menu_name}
                                    </h5>
                                  </div>
                                  <h5 className="dark-text fw-bold mb-1">
                                    {items.menu_name}
                                  </h5>
                                </>
                              )}
                              Size : {items.menu_size_name} ({items.size})<br />
                              Qty : {items.qty} <br />
                              Price : $
                              {parseFloat(items.total_amount).toFixed(2)}
                              <br />
                              Note : {items.note}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>

                  <section className="bill-details section-lg-b-space">
                    <div className="custom-container p-0">
                      <h3 className="fw-bold dark-text">Est Rate Details</h3>
                      <table className="table table-sm mt-2 text-2">
                        <tbody>
                          {item.is_direct_order === 0 ? (
                            <>
                              {" "}
                              <tr>
                                <td className="dark-text mb-1">Sub Total </td>
                                <td className="text-end">
                                  {" "}
                                  ${parseFloat(TotalAmount)?.toFixed(2)}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                {/* <td className="dark-text fw-bold mb-1">Discount </td><td className='text-end'> ${formData.discount > 0 ? formData.discount:0 }</td><td> </td> */}
                                <td className="dark-text mb-1">Discount </td>
                                <td className="text-end">
                                  {" "}
                                  $
                                  {parseFloat(reviewData?.discount)?.toFixed(2)}
                                </td>
                                <td> </td>
                              </tr>
                              <tr>
                                {/* <td className="dark-text fw-bold mb-1">Sales Tax </td><td className='text-end'> ${formData.discount > 0 ? formData.grand_total - formData.discount :formData.grand_total}</td><td></td> */}
                                <td className="dark-text  mb-1">
                                  Sales Tax ({item?.tax}%)
                                </td>
                                <td className="text-end">
                                  {" "}
                                  ${reviewData?.sales_tax}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td className="dark-text mb-1 ">Total </td>
                                <td className="text-end fw-bold">
                                  {" "}
                                  ${parseFloat(reviewData?.total)?.toFixed(2)}
                                </td>
                                <td></td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td>Est Total</td>
                              <td className="text-end fw-bold">
                                $ {TotalAmount.toFixed(2)}
                              </td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {item.is_direct_order === 1 ? (
                      <Segmented tag="p" className="mb-3">
                        <Button
                          large
                          className={"btn btn-success"}
                          role="button"
                          onClick={() => acceptOrder(item.id)}
                        >
                          {"Accept Order"}
                        </Button>
                        <Button
                          large
                          className={"btn btn-danger"}
                          role="button"
                          onClick={() => cancelConfirm(item.id)}
                        >
                          {"Cancel Order"}
                        </Button>
                      </Segmented>
                    ) : (
                      ""
                    )}
                  </section>

                  {/* <div className="row gy-3">
                
                {item.rest_item.map((items, index) => (
                      
                      <div className="col-12">
                    <div className='vertical-product-box order-box '>
                      <div className="bid-items-view">
                        <div className="vertical-box-head">
                          <div className="restaurant d-flex justify-content-between col">
                            <h4 className="dark-text fw-bold col-6 p-1">
                            {items.menu_name}
                            </h4>
                            <div className=''>
                            <h6 className="food-items text-black mb-2">Total Amount : {items.total_amount}</h6>
                            <h6 className="food-items text-black mb-2">Menu Size : {items.menu_size_name}</h6>
                            <h6 className="food-items text-black mb-2 ">Qty : {items.qty}</h6>
                            </div>
                            
                          </div>
                          <h6 className="food-items  p-1"><h6 className="food-items text-black mb-2">Note : {items.note}</h6></h6>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                
                ))}
                
              </div> */}
                </div>
              ) : null}
              {item.status_of_event_id !== 2 &&
              item.status_of_event_id !== 6 &&
              item.order_status === 1 &&
              bidMenu.length > 0 ? (
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Review Menu Items</h3>
                  <table className="table table-striped table-sm text-2 mt-2">
                    <tbody>
                      {bidMenu.map((items, index) => (
                        <tr className="align-middle">
                          <td width={"10%"} className="text-center">
                            {index + 1}.{" "}
                          </td>
                          <td>
                            {items.request_menu_id === items.menu_id ? (
                              <h5 className="dark-text fw-bold mb-1">
                                {items.menu_name}
                              </h5>
                            ) : (
                              <>
                                <div style={{ display: "flex" }}>
                                  <h5 style={{ marginRight: "10px" }}>
                                    Requested:
                                  </h5>
                                  <h5
                                    className="dark-text fw-bold mb-1"
                                    style={{
                                      textDecoration: "line-through",
                                      color: "black",
                                      textDecorationColor: "red",
                                    }}
                                  >
                                    {items.request_menu_name}
                                  </h5>
                                </div>
                                <h5 className="dark-text fw-bold mb-1">
                                  {items.menu_name}
                                </h5>
                              </>
                            )}
                            Qty : {items.tray_size_id}, Price: $
                            {parseFloat(items.total_amount).toFixed(2)}
                            {items.note && <span>, {items.note}</span>}{" "}
                          </td>
                          {/* <td width={'10%'}><Button fill small className="text-white btn-danger filter-button mt-1 text-1 p-0" onClick={() => removeItem(index)}>Delete</Button></td> */}
                          {/* <td width={'20%'} className='text-center text-md-end'><a href="#" className="btn btn-xs btn-danger order mt-2 p-1 text-3" role="button" onClick={() => removeItem(index)}> &nbsp; Delete &nbsp; </a></td> */}
                          <td width={"15%"} className="text-center">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Button
                                className={`${
                                  remainingTime < 0 ? "disabled" : ""
                                }`}
                                onClick={() => {
                                  reviewAddToItem(items.menu_name);
                                  setRequestedMenu(items?.request_menu_name);
                                  setRequestedMenuId(items?.request_menu_id);
                                  setEventItemId(items.event_item_id);
                                  setTraySizeId(items.tray_size_id);
                                  setMenuSizeId(items.menu_size);
                                  setMenuAmount(items.menu_amount);
                                  setNoOfPer(items.size);
                                  setMenuNote(items.note);
                                }}
                              >
                                <Icon
                                  material="edit"
                                  className="text-success"
                                ></Icon>
                              </Button>
                              <a
                                href="#"
                                role="button"
                                onClick={() => removeItem(index)}
                              >
                                {" "}
                                <Icon
                                  material="delete"
                                  className="text-danger"
                                ></Icon>{" "}
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : null}

              {item.status_of_event_id !== 2 &&
              item.status_of_event_id !== 6 &&
              item.order_status === 1 ? (
                <div>
                  {/* <div className={`custom-container p-0 ${remainingTime < 0 ? "disabled" :''}`}>
                    <div class="title">
                      <h3 class="mt-0">Add Menu Details</h3>
                      <a href="#"><Button fill small className="text-white btn-success filter-button mt-1 text-1" popupOpen=".demo-popup"> Add Item Details </Button></a>
                    </div>
                  </div> */}

                  <div className="custom-container p-2">
                    <table
                      className="col-5"
                      style={{ float: "right", marginRight: "0px" }}
                    >
                      <tr>
                        <td className="dark-text fw-bold mb-1">Sub Total </td>
                        <td className="text-end">
                          {" "}
                          ${parseFloat(calculatedValues?.sub_total)?.toFixed(2)}
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        {/* <td className="dark-text fw-bold mb-1">Discount </td><td className='text-end'> ${formData.discount > 0 ? formData.discount:0 }</td><td> </td> */}
                        <td className="dark-text fw-bold mb-1">Discount </td>
                        <td className="text-end">
                          {" "}
                          ${parseFloat(calculatedValues?.discount)?.toFixed(2)}
                        </td>
                        <td> </td>
                      </tr>
                      <tr>
                        {/* <td className="dark-text fw-bold mb-1">Sales Tax </td><td className='text-end'> ${formData.discount > 0 ? formData.grand_total - formData.discount :formData.grand_total}</td><td></td> */}
                        <td className="dark-text fw-bold mb-1">
                          Sales Tax ({formData.sales_tax}%)
                        </td>
                        <td className="text-end">
                          {" "}
                          ${calculatedValues.sales_tax}
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td className="dark-text fw-bold mb-1">Total </td>
                        <td className="text-end">
                          {" "}
                          ${parseFloat(calculatedValues?.total)?.toFixed(2)}
                        </td>
                        <td></td>
                      </tr>
                    </table>
                    <div className="form-group col-4">
                      <div className="mb-2 mt-2  p-2">
                        <ListItem>
                          <span className="p-2">Sales Tax</span>
                          <Toggle
                            onChange={handleSalesTaxToggle}
                            checked={isSalesTaxEnabled}
                            color="green"
                          />
                        </ListItem>
                      </div>
                      <label className="form-label fw-semibold">
                        Add Discount
                      </label>
                      <div className="mb-4">
                        <Input
                          type="text"
                          // required
                          validate
                          // pattern="[0-9\s]{1,4}"
                          pattern="^[0-9]*\.?[0-9]+$"
                          errorMessage="Please enter correct value."
                          className="form-control"
                          placeholder="Discount "
                          name="discount"
                          onChange={discountAddItem}
                          value={formData.discount}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={`custom-container p-0 ${
                      remainingTime < 0 ? "disabled" : ""
                    }`}
                  >
                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-success w-100 mt-0 mb-3"
                      onClick={showConfirm}
                      large
                      role="button"
                    >
                      {isSubmitting ? "Submitting..." : "Submit Bid"}
                    </Button>
                  </div>
                  {/* <Button type="submit" className="btn theme-btn w-100 mt-4" large disabled={isSubmitting}>
                    {isSubmitting ? 'Signing Up...' : 'Sign Up'}
                  </Button> */}
                </div>
              ) : item.status_of_event_id === 5 ||
                item.status_of_event_id === 6 ||
                item.order_status === 5 ? (
                <div className="custom-container p-0 disabled">
                  <Button
                    type="submit"
                    className="btn btn-danger w-100 mt-0"
                    large
                    role="button"
                  >
                    Cancelled{" "}
                  </Button>
                </div>
              ) : (
                ""
              )}
            </section>
          ))}
          <Popup className="demo-popup custom-web ">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  {/* <div className="modal-title">
                      <h3 className="fw-bold">Add Item Details</h3>
                      <Link className="btn-close" popupClose/>
                    </div> */}
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link />
                        <h2>Update Item Details</h2>
                        <Link
                          className="btn-close"
                          popupClose
                          style={{ marginRight: "15px" }}
                        />
                      </div>
                    </div>
                  </header>
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form
                        id="formAddCart"
                        ref={formRef}
                        onSubmit={handleSubmit}
                        className="auth-form profile-form"
                      >
                        <div class="title">
                          <h3 class="mt-0">Menu Details</h3>
                          {/* <a href="#">
                            <Button
                              fill
                              small
                              className="text-white btn-success filter-button mt-1 text-1"
                              onClick={addNewMenu}
                            >
                              {" "}
                              Add New Menu{" "}
                            </Button>
                          </a> */}
                        </div>
                        {/* <div class="title">
                          <h5 className="fw-bold dark-text dark-text">Menu Details</h5>
                          <a href="#" className='btn btn-xs btn-success text-1 text-white' onClick={addNewMenu} >Add New Menu</a>
                        </div> */}{" "}
                        {/* <div className="form-group">
                          <label className="form-label fw-semibold">
                            Requested Menu
                          </label>
                          <div className="form-input mb-4">
                            <h3>{requestedMenu}</h3>
                          </div>
                        </div> */}
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Name
                          </label>
                          <div className="form-input mb-4">
                            <input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              required
                              validate
                              value={searchTerm}
                              name="menu_name"
                              autoComplete="off"
                              // value={product.menu_name}
                              onChange={handleMenuChange}
                              placeholder="Type to search..."
                            />
                          </div>
                        </div>
                        {/* <Button type="button" onClick={addNewMenu} small className="btn btn-sm btn-success save-address w-100 mb-3">
                                  Add New Menu
                              </Button>  */}
                        <div className="form-group">
                          {suggestions.length > 0 && (
                            <ul className="auto-complete-list ">
                              {suggestions.map((item) => (
                                <li
                                  key={item.id}
                                  onClick={() => {
                                    handleItemSelect(
                                      item.menu_item_name,
                                      item.menu_item_id,
                                      item.menu_size
                                    );
                                  }}
                                >
                                  {item.menu_item_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Size
                          </label>
                          <div className="form-input mb-4">
                            <select
                              name="menu_size"
                              id="menu_size"
                              className="form-select form-control"
                              required
                              validate
                              value={menuSizeId}
                              onChange={(event) => {
                                const selectedIndex =
                                  event.target.selectedIndex;
                                const selectedOption =
                                  event.target.options[selectedIndex];
                                const newValue =
                                  selectedOption.getAttribute("value");
                                setMenuSizeId(event.target.value);
                                // console.log("setMenuSizeId", menuSizeId);
                                menuSizeAmount(
                                  selectedOption.getAttribute("amount"),
                                  selectedOption.getAttribute("data-size")
                                );
                                // setMenuSizeId(event.target.value, () => {
                                //   menuSizeAmount(
                                //     selectedOption.getAttribute("amount"),
                                //     selectedOption.getAttribute("data-size")
                                //   );
                                // });

                                // Log inside the callback
                              }}
                            >
                              <option amount={0}> Select Menu Size</option>
                              {menuSize.length > 0 && (
                                <>
                                  {menuSize.map((item) => (
                                    <option
                                      key={item.id}
                                      amount={item.menu_amount}
                                      data-size={item.size}
                                      value={item.menu_size_id}
                                    >
                                      {item.menu_size_name} ({item.size})
                                    </option>
                                  ))}
                                </>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Serves
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="noOfPer"
                              className="form-control"
                              required
                              validate
                              value={noOfPer}
                              name="noOfPer"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Amount
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="menu_amount"
                              className="form-control"
                              // required
                              // validate
                              value={menuAmount}
                              name="menu_amount"
                              onChange={handleMenuAmountChange}
                              min="0"
                              pattern="[0-9]+([.][0-9]{0,2})?"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Tray Count/No of Pieces
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="number"
                              id="try_size"
                              className="form-control"
                              name="try_size"
                              value={traySizeId}
                              onChange={(e) => {
                                const newValue = parseInt(e.target.value);
                                setTraySizeId(newValue);
                                calculateSum(newValue);
                              }}
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Total Amount
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="number"
                              id="total_amount"
                              className="form-control"
                              name="total_amount"
                              value={parseFloat(totalAmt).toFixed(2)}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Menu Note
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="menu_note"
                              className="form-control"
                              name="menu_note"
                              value={menuNote}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                setMenuNote(newValue);
                              }}
                            />
                          </div>
                        </div>
                        <Button
                          type="submit"
                          fill
                          large
                          className="btn theme-btn save-address w-100"
                        >
                          Add Item
                        </Button>
                        {/* <Button type="button" onClick={addNewMenu} fill large className="btn btn-success save-address w-100">
                                  Add Menu 
                              </Button>    */}
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
        </div>
      </div>
    </Page>
  );
};

export default EventDetailPage;
